<template>
  <el-row>
    <el-col :span="24" class="center_content_right_list">
      <div class="center_content_right_bottom">
        <div class="center_content_right_title">广播资源

          <img src="@/assets/img/drillCenter/line.png" style="width: 78px;height: auto;" alt="">

        </div>
        <template v-if="audioList.length > 0">
          
          <div class="broadcast_list">
            <vueSeamlessScroll
              v-if="audioList.length > 0"
              :data="audioList"
              :class-option="defaultOption"
              class="seamless-warp"
            >
            <div
                  v-for="(item, index) in audioList"
                  :key="index"
                  :class="index%2==0?'list-li':'double list-li'"
                >
                <div class="broadcast_name">
                  <img    @click="selRadio(item)" src="@/assets/img/drillCenter/laba.png" style="width: 25px;height: 25px;" alt="">

                      {{ item.resourceName }}
                    </div>
                    <!-- <div
                      v-if="item.state==0"
                      class="player_button"
                      @click="selRadio(item)"
                    >
                      <img src="@/assets/img/drillCenter/play.png" alt="">
                    </div>
                    <div
                      v-if="item.state==1"
                      class="player_button"
                      @click="selRadioStop(item)"
                    >
                    <img src="@/assets/img/drillCenter/pause.png" alt="">
                    </div> -->
                </div>
            </vueSeamlessScroll>
          </div>
        </template>
        <template v-else>
          <div class="no-audio">暂无应急广播</div>
        </template>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  name: "drillCenterAudio",
  components: {
    vueSeamlessScroll 

  },
  props: {
    startStatus: {
      type: Number,
      default: {
        return: 0
      }
    },
    audioList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      broadcastBrand: "", // 0 智慧广播，1 云广播
      selectRadio: {}, // 选中的广播
      tids: [], // 终端id数组
      catalogId: "", // 节目id
      vol: 56, // 音量 1-56
      sId: "", // 会话id
      status: 0, // 广播播放状态 0-stop 1- play 2- pause
      audioImg: "audio-stop.png",
      statusImg: {
        playImg: "audio-play.gif",
        stopImg: "audio-stop.png"
      },
      time: ""
    };
  },
  created() {
    this.getBroadcastAreaInfo();
    this.getBroadcastBrand();
    window.addEventListener("beforeunload", () => {
      if (this.status == 1) {
        this.selRadioStop();
      }
    });
  },
  mounted() {},
  computed: {
  
    defaultOption() {
      return {
        step: 0.3, //步长 越大滚动速度越快
        limitMoveNum: 3, //启动无缝滚动最小数据量 this.dataList.length
        hoverStop: true, //是否启用鼠标hover控制
        direction: 1, //1 往上 0 往下
        openWatch: true, //开启data实时监听
        singleHeight: 0, //单条数据高度有值hoverStop关闭
        waitTime: 1000 //单步停止等待时间
      };
    }
  },
  watch: {
    startStatus: function(newVal) {
      if (newVal == 0 && this.status == 1) {
        this.selRadioStop();
      }
    }
  },
  methods: {
    // 获取校园广播品牌
    async getBroadcastBrand() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getBroadcastBrand(req);
      if (res.code == 200) {
        this.broadcastBrand = res.data;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 云广播播放音乐
    async playBroadcastCloud(fileId) {
      let req = {
        tids: this.tids,
        fileId: fileId,
        resources: 1
      };

      let res = await this.$Http.playBroadcastCloud(req);
      if (res.code == 200) {
        this.sId = Number(res.data.ultaskcode);
        this.status = 1;
        this.changeRadioShow(this.status);
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 选择播放的广播
    selRadio(item) {
      if (this.startStatus == 0) {
        this.$message("预案未启动，应急直播不能查看，请先开启预案！");
        return;
      }
      if (this.status == 1) {
        this.$message("存在正在播放的广播，请关闭后再播放！");
        return;
      }
      // console.log(item);
      this.$confirm("确定播放广播吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.selectRadio = item;
          this.catalogId = item.safeVoice.catalogId;
          // console.log(this.catalogId);
          // this.createBroadcastSession();
          if (this.broadcastBrand == 0) {
              this.createBroadcastSession();
          } else {
              this.playBroadcastCloud(item.safeVoice.fileId);
          }
        })
        .catch(() => {});
    },
    // 播放广播
    playRadio(item) {
      this.status = 1;
      this.playControlBroadcast();
    },
    // 停止广播
    selRadioStop(item) {
      this.status = 0;
      if (this.broadcastBrand == 0) {
        this.playControlBroadcast();
      } else {
        this.changeRadioShow(this.status);
      }
    },
    changeRadioShow(num) {
      if (num == 0) {
        // console.log("停止播放");
        this.audioImg = this.statusImg.stopImg;
        let audioList = this.audioList;
        audioList.forEach((element, index) => {
          audioList[index].playStatus = false;
          // if(item.id == element.id){
          //     audioList[index].playStatus = false;
          // }
        });
        this.audioList = audioList;
        this.delBroadcastSession();
      } else if (num == 1) {
        // console.log("开始播放");
        this.audioImg = this.statusImg.playImg;
        let audioList = this.audioList;
        audioList.forEach((element, index) => {
          audioList[index].playStatus = false;
          if (this.selectRadio.id == element.id) {
            audioList[index].playStatus = true;
          }
        });
        // 触发父组件方法添加演练记录
        this.$emit("getRadioRecord", this.selectRadio.safeVoice.voiceName);
      } else {
      }
    },
    startCountdown() {
      let time = this.time;
      // 播放结束后从头播放
      setTimeout(() => {
        this.status = 1;
        this.playControlBroadcast();
      }, time * 1000);
    },
    // 应急广播-获取分区信息
    async getBroadcastAreaInfo() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getBroadcastAreaInfo(req);
      if (res.code == 200) {
        // console.log(res);
        if (res.data.length > 0) {
          let tids = [];
          res.data.forEach((element) => {
            tids.push(Number(element.areaNum));
          });
          this.tids = tids;
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 应急广播-创建会话
    async createBroadcastSession() {
      let req = {
        tids: this.tids,
        catalogId: this.catalogId,
        vol: this.vol
      };
      let res = await this.$Http.createBroadcastSession(req);
      if (res.code == 200) {
        // console.log(res);
        this.sId = Number(res.data);
        this.playBroadcast();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 应急广播-播放媒体库文件
    async playBroadcast() {
      let req = {
        sId: this.sId,
        catalogId: this.catalogId
      };
      let res = await this.$Http.playBroadcast(req);
      // console.log(res);
      if (res.code == 200) {
        this.time = Number(res.data);
        this.playRadio();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 应急广播-文件广播播放控制
    async playControlBroadcast() {
      let req = {
        sId: this.sId,
        status: this.status
      };
      let res = await this.$Http.playControlBroadcast(req);
      // console.log(res);
      if (res.code == 200) {
        this.changeRadioShow(this.status);
        if (this.status == 1) {
          this.startCountdown();
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 应急广播-删除文件广播会话
    async delBroadcastSession() {
      let req = {
        sId: this.sId
      };
      let res = await this.$Http.delBroadcastSession(req);
      // console.log(res);
      if (res.code == 200) {
        // this.sId = Number(this.data);
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  destroyed() {
    // if(this.status == 1){
    //   this.selRadioStop();
    // }
    // if(this.sId != '') {
    //   this.delBroadcastSession();
    // }
  }
};
</script>
<style lang="scss" scoped>
.center_content_right_list {
  // padding: 2rem;
  margin-top: 20px;
}
.center_content_right_bottom {
  // background-image:url();
  background-image: url('~@/assets/img/drillCenter/right_bottom.png');
  background-size: 100% 100%;
  padding: 1rem;
  border-radius: 1rem;
height: 525px;
}
.center_content_right_title {
  color: #fff;
  font-weight: 500;
font-size: 16px;
color: #FFFFFF;
display: flex;
flex-direction: column;
}
.center_content_right_title::after{

}
.center_content_right_player {
  height: 60px;
  position: relative;
  padding: 0;
  margin:20px 0 14px ;
}
.center_content_right_player audio {
  width: 100%;
  opacity: 0;
}
.audio-img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.broadcast_list {
  margin-top: 20px;
  padding-bottom: 1rem;
  height: 450px;
  overflow: hidden;
}
.list-li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0; 
  
}
.double{
  background: linear-gradient( 90deg, rgba(7,93,178,.36) 0%, #0C324D 86%, rgba(12,33,77,0.2558) 100%);
  
}
.player_button {
  padding: 0.5rem 1.6rem;
  border-radius: 0.6rem;
  text-align: center;
  
  cursor: pointer;
  // background: linear-gradient( 180deg, rgba(81,193,255,0.2627) 0%, rgba(69,189,255,0) 29%, rgba(45,181,255,0) 72%, rgba(36,178,255,0.26) 100%);
}
.player_button img{
  width: 20px;
  height: auto;
}
.broadcast_name {
  color: rgba($color: #fff, $alpha: .9);
  font-weight: 400;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1;
}
.no-audio {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 16px;
}
</style>
